import { MVersionsZeile, useLogout, useMe, useTheme } from "@vimaana/ui";
import Shell from "../components/Shell";
import EinzugswegKarte from "../components/EinzugswegKarte";
import QontoZugang from "../components/QontoZugang";
import { useEinzugVorschau } from "../hooks/useLastschrift";

/**
 * Einstellungen — was man einmal einstellt und dann nicht mehr anfasst.
 * Wie in Kontor steht hier auch der Stand der App („Nach Updates suchen").
 */
export default function EinstellungenPage() {
  const { data: vorschau } = useEinzugVorschau();
  const weg = vorschau?.einzugsweg;
  const { theme, setTheme } = useTheme();
  const { data: me } = useMe("pflege");
  const logout = useLogout("pflege");

  return (
    <Shell title="Einstellungen" subtitle="Einzugsweg, Darstellung und Konto">
      <div className="pf-seclabel" style={{ marginTop: 0 }}>Raten einziehen</div>
      <EinzugswegKarte weg={weg} />
      {weg === "qonto" && <QontoZugang />}

      <div className="pf-seclabel">Darstellung</div>
      <div className="pf-card" style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        <span style={{ flex: "1 1 200px" }}>Farbthema — gilt für dieses Gerät</span>
        <button type="button" className={"pf-chip" + (theme === "light" ? " is-on" : "")}
          aria-pressed={theme === "light"} onClick={() => setTheme("light")}>Hell</button>
        <button type="button" className={"pf-chip" + (theme === "dark" ? " is-on" : "")}
          aria-pressed={theme === "dark"} onClick={() => setTheme("dark")}>Dunkel</button>
      </div>

      <div className="pf-seclabel">Konto</div>
      <div className="pf-card" style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
        <span style={{ flex: "1 1 200px", minWidth: 0, overflowWrap: "anywhere" }}>
          {me?.full_name || me?.email || "Angemeldet"}
          {me?.email && me?.full_name ? <span style={{ color: "var(--vg-text-3)" }}> · {me.email}</span> : null}
        </span>
        <button type="button" className="pf-btn is-ghost" onClick={() => logout.mutate()}>Abmelden</button>
      </div>

      <div className="pf-seclabel">App</div>
      <MVersionsZeile name="Vimaana Pflege" />
    </Shell>
  );
}
